import { EventEmitter, Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class ProductCountryService {
  public newCountry$ = new EventEmitter<string>();
  public countries: string[] = [];

  public init(countries: string[]) {
    if (countries.length === 0) {
      return;
    }

    for (const country of countries.map((value) => this.normalizeCountry(value)).filter(Boolean)) {
      if (!this.countries.includes(country)) {
        this.countries.push(country);
      }
    }
  }

  selectCountry(country: string): string[] {
    const normalizedCountry = this.normalizeCountry(country);
    if (normalizedCountry && !this.countries.includes(normalizedCountry)) {
      this.countries.push(normalizedCountry);
      this.newCountry$.emit(normalizedCountry);
    }
    return this.countries;
  }

  private normalizeCountry(country: string) {
    return country?.trim().toUpperCase() ?? "";
  }
}
